// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact__container-e4908a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.Contact__contact-e5f7bb {
  height: 58px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Payloads/Contact/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.contact {\n  height: 58px;\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Contact__container-e4908a`,
	"contact": `Contact__contact-e5f7bb`
};
module.exports = ___CSS_LOADER_EXPORT___;
